export default __webpack_public_path__ + "static/Sidebar_desktop_TSX_logo_green-cb64e426bbd4af71c2c572d8f3ba9cc7.svg";